import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { SubscriptionEvent } from './subscription_events';

@Injectable({ providedIn: 'root' })
export class SubscriptionEventProvider extends DomainEventProvider<SubscriptionEvent> {}
